import { Injectable } from '@angular/core';
import { BalanceSheetPrintQuery, BalanceSheetPrintQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(BalanceSheetPrintQuery)
@Wrapper(BalanceSheetPrintQueryHandlerBase)
export class BalanceSheetPrintQueryHandler {
    public constructor(
        http: Http
    ) { }
}
